module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// /payu/microservice/multichannelportal/src/vendor/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = ../../../../../src/vendor/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module chunks = styles